import script from "./datamapEditor.vue?vue&type=script&lang=js"
export * from "./datamapEditor.vue?vue&type=script&lang=js"

import "./datamapEditor.vue?vue&type=style&index=0&id=b2d7b99a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2d7b99a"]])

export default __exports__